module.exports = function(users) {
	"use strict";
  users
  .controller('allusersController', allusersController)
	allusersController.$inject = ["comunicateBetweenViews","$timeout","$stateParams","$state","API_URL","$http","$scope","$rootScope","NgTableParams","getDataService",'jQuery','refreshtokenService','reqursiveService','serverError','alertService','offlineError'];
	
    function allusersController(comunicateBetweenViews,$timeout,$stateParams,$state,API_URL,$http,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,serverError,alertService, offlineError) {
      var vmau = this;
      var state = 'users';
      var s;
      var role;
      var $data;
      var page;
      var status;
      vmau.role = 'all';
      vmau.selectedStatus = {'value':'all'};
      $rootScope.hasLoaded = false;
      vmau.editUserShow = false;
      vmau.userId = $stateParams.id; 
      if($stateParams.id) {
        vmau.editUserShow = true;
      } else {
        vmau.editUserShow = false;
      }
      vmau.selectedRole = {value: 'all'}; 
      vmau.selectedBulkAction = {value: 'default'};
      vmau.deleteUserFunction = function(data) {
        var deleteFunction = function() {
          $http.delete(API_URL + state , data)
          .success(function (data, status, headers) {
              $rootScope.hasLoaded = true;
              alertService('success','Success ', data.message, 2000);
              vmau.tableParams.reload();
          })
          .error(function (data, status, header, config) {
            if(!window.navigator.onLine) {
              offlineError()
              $rootScope.hasLoaded = true;
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            }
            if(status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    deleteFunction();
                  }
                },
                function(error) {
                },
                function(progress) {
                 // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else {  
              alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
            }
            $rootScope.hasLoaded = true; 
          });
        }
        deleteFunction();
      }
      vmau.deleteUser = function(id) {
        $rootScope.hasLoaded = false;
        var dataIds = {
          'ids':[id]
        };
        vmau.deleteUserFunction(dataIds);  
      }
      vmau.editUser = function(userId) {
        vmau.editUserShow = true;
        jQuery("html, body").animate({
          scrollTop: 0
        }, 600);
        vmau.userId = userId;
        $state.transitionTo('app.allusers', {id: vmau.userId}, {
          location: true,
          inherit: true,
          relative: $state.$current,
          notify: false
        });
      }
      vmau.authorPosts = function(userId) {
        comunicateBetweenViews.setAuthor(userId);
        $state.go('app.allposts'); 
      }
      var getUsersFunction = function() {
        getDataService.get({param1:'users', param2: 'roles', param3:null}).$promise.then(function(data){
          vmau.roles = data.roles;
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            return
          }
          if(error.status == 401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
            function(answer) {
              if(answer==200) {
                getUsersFunction();
              }
              // do something
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
            });
          }else if(error.status ==502) {
            serverError();
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }  
        });
      }
      vmau.switchStatusFilter = function(item) {
          vmau.selectStatus = item;
      }
      vmau.changeSearch = function(search_data) {
        vmau.switchSearch = true;
        if(search_data) {
          vmau.searchData = search_data;
        } else {
          vmau.searchData = null;
          $timeout(function() {
            vmau.search();
          },0)            
        }
      }
      vmau.tableActionsFunction = function(params) {
        var reloadTableFunction = function() {
          params.page(1);
          vmau.tableParams.reload();
        } 
        vmau.resetAllFilters = function() {
          vmau.role = 'all';
          role = null;
          vmau.searchData = null;
          s =null;
          status = null;
          vmau.selectedStatus = {'value':'all'}
          $scope.$broadcast('clear-daterange',true);
          reloadTableFunction();
        }
        vmau.postFilter = function() {
          s=vmau.searchData;
          if (s) {
            s = s.toLowerCase();
          } else {
            s = null;
          }
          status = vmau.selectStatus;
          if (status == 'all') {
              vmau.selectStatus = null;
              status = null;
          }
          reloadTableFunction();
        }

        vmau.changeStatus = function(event,activeRole) {
          vmau.role = activeRole;
          if(activeRole) {
            role = activeRole;
          } 
          if(activeRole=='all') {
            role=null;
          }
          vmau.searchData = null;
          s = null;
          status = null;
          vmau.selectedStatus = {'value':'all'}
          $scope.$broadcast('clear-daterange',true);
          reloadTableFunction();
        }
        vmau.search =function(value) {
          if(value) {  
            s = value.toLowerCase();
          } else {
            s = null;
          }
          // role= null;
          reloadTableFunction();
        }
      }
      vmau.tableReloadFunction = function(page) {
        vmau.tableParams = new NgTableParams({
            page: page || 1,
            count: 20,
            
        }, {
        getData: function(params) {
          
          $rootScope.hasLoaded = false;
          return getDataService.get({
            param1: state,
            param2: null,   
            s:s,
            role: role,
            page: params.page(),
            limit: params.count(),
            status: status,
            sortby: $rootScope.sortby,
            sort : $rootScope.sort,
            }).$promise.then(function(data){
            $rootScope.emptyTable = false;
            $rootScope.hasLoaded = true;
            $data = data.users; 
            if(data.users.length == 0) {
              $rootScope.emptyTable = true;
            } 
            params.total(data.count);
            params.numPages(data.max_pages);
            jQuery('.goTo input').val("");
            vmau.tableActionsFunction(params);
            getUsersFunction();
            return $data;
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              $rootScope.hasLoaded = true;
              return
            }
            if(error.status ==401) {
              
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                 
                  if(answer==200) {
                    vmau.tableReloadFunction(params.page());
                  }
                  // do something
                },
                function(error) {
                  // report something
                },
                function(progress) {
                 // report progress
                });
            }else if(error.status ==404) {
              $rootScope.emptyTable = true;
            } else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            }
            $rootScope.hasLoaded = true;
            vmau.tableActionsFunction(params);
          });
        }    
      });
    }
    vmau.tableReloadFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/usersModule/allusers/js/allusersController.js
// module id = 632
// module chunks = 0